@if (isLoading) {
	<div class="overlay-new"></div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading">{{ 'mes.administration.batch.batches' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field">
			<mat-form-field>
				<input matInput (keyup)="applyFilter($event)" [placeholder]="'insights.administration.users.search' | translate" #input [cdkTrapFocusAutoCapture]="showSearch" [cdkTrapFocus]="showSearch" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<header-sub-menu [favoriteItems]="favoriteItems"></header-sub-menu>
	</div>
</div>

<div class="table-wrapper">
	<table mat-table recycleRows [dataSource]="dataSource" matSort (matSortChange)="onSort($event)">
		<ng-container matColumnDef="name">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.batch.shared.name' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">
				<div class="batch-name" [class.batch-name-reorder]="element.level > 0" [style.margin-left.px]="element.level * 32">
					<span class="batch-name-content">({{ element.alias }}) {{ element.name }}</span>
				</div>
			</td>
		</ng-container>
		<ng-container matColumnDef="status">
			<th mat-header-cell *matHeaderCellDef mat-sort-header>
				{{ 'mes.administration.batch.shared.status' | translate }}
			</th>
			<td mat-cell *matCellDef="let element">
				<div class="status">
					{{ 'mes.administration.batch.shared.statuses.' + (element.status | lowercase) | translate }}

					<app-batch-status [errors]="element.errors"></app-batch-status>
				</div>
			</td>
		</ng-container>
		<ng-container matColumnDef="menu">
			<th mat-header-cell *matHeaderCellDef style="text-align: end"></th>
			<td mat-cell *matCellDef="let row" style="text-align: end">
				<button *ngIf="!row.isReorder" mat-icon-button [matMenuTriggerFor]="menu">
					<mat-icon mat-list-icon svgIcon="acies_overflow_menu" style="padding-top: 5px"></mat-icon>
				</button>
				<mat-menu #menu="matMenu">
					<button mat-menu-item (click)="openEdit(row.batch)">
						<span>{{ 'mes.administration.batch.shared.editbtn' | translate }}</span>
					</button>
					<button mat-menu-item (click)="openDelete(row.batch)">
						<span>{{ 'mes.administration.batch.shared.deletebtn' | translate }}</span>
					</button>
				</mat-menu>
			</td>
		</ng-container>
		<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns" [class.batch-reorder-row]="row.isReorder" [class.batch-orphan-reorder-row]="row.isOrphanReorder"></tr>
	</table>
</div>

<mat-paginator [pageSizeOptions]="[10, 20, 50, 100, 200, 500, 1000, 2000, 5000]" [pageSize]="1000" showFirstLastButtons></mat-paginator>
